import { IModelField, IModelScalaField, IModelEnumField } from '../editor/index.d';

/**
 * 判断路径path是否在target中存在
 * @param path 路径，必须以this开头
 * @param fqn 目标对象
 */
export function matchFqnPath(fqn: IModelField, path: string) {
  const paths = path.split('.');
  paths.shift(); // 去掉this
  let obj: IModelField | IModelScalaField | IModelEnumField = fqn;
  while (paths.length > 0) {
    const subPath = paths.shift()!;
    const isArrayPath = subPath.endsWith('[]');
    const realPath = isArrayPath ? subPath.substr(0, subPath.length - 2) : subPath;
    if (obj && ['Object'].includes(obj.type)) {
      obj = (obj as IModelField).fields[realPath];
      // 数组路径需要确保字段为数组
      if (isArrayPath && obj && !obj.isArray) {
        return null;
      }
      if (!isArrayPath && obj && obj.isArray) {
        return null;
      }
    } else {
      return null;
    }
  }
  return obj;
}


export function mathModelField(model: IModelField, path: string) {
  const paths = path.split('.');
  let field: IModelField | IModelScalaField | IModelEnumField = model;
  while (paths.length) {
    const subPath = paths.shift()!;
    const isArrayPath = subPath.endsWith('[]');
    const realPath = isArrayPath ? subPath.substr(0, subPath.length - 2) : subPath;
    if (field && ['Object', 'Array', 'Tree'].includes(field.type)) {
      field = (field as IModelField).fields[realPath];
      // 数组路径需要确保字段为数组
      if (isArrayPath && field && !field.isArray) {
        return null;
      }
    } else {
      return null;
    }
  }
  return field;
}
